import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation DocumentCourse_create($courseId: ID!, $name: String!, $size: Int!, $url: String!) {
    DocumentCourse_create(courseId: $courseId, name: $name, size: $size, url: $url) {
      courseId
      name
      size
      url
      id
    }
  }
`;

const documentCourseCreate = async ({ courseId, name, size, url }) =>
  graphql(mutation, { courseId, name, size, url }).then(
    // eslint-disable-next-line camelcase
    ({ DocumentCourse_create }) => DocumentCourse_create
  );

export default documentCourseCreate;
